import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import Event from '../../modules/analytics/components/Event';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../modules/analytics/components/Event/Event.constants';
import { EventPropType } from '../../modules/analytics/types';
import Icon from '../../modules/foundation/components/Icon/Icon';
import { classNames } from '../../utils/classname';
var defaultProps = {
  className: '',
  iconName: '',
  ariaLabel: 'Call Business',
  event: {
    category: EVENT_CATEGORIES.CONTACT_EVENT_CATEGORY,
    action: EVENT_ACTIONS.CONTACT_CALL_EVENT_ACTION
  }
};
export default function Phone(_ref) {
  var phone = _ref.phone,
    className = _ref.className,
    iconName = _ref.iconName,
    ariaLabel = _ref.ariaLabel,
    event = _ref.event;
  if (_isEmpty(phone)) {
    return null;
  }
  function getContent() {
    if (!_isEmpty(iconName)) {
      return /*#__PURE__*/React.createElement(Icon, {
        iconName: iconName
      });
    }
    return phone;
  }
  var finalClassName = classNames(_defineProperty({
    phone: true
  }, className, true));
  var phoneLink = /*#__PURE__*/React.createElement("a", {
    className: finalClassName,
    href: "tel:".concat(phone),
    "aria-label": ariaLabel
  }, getContent());
  if (!_isEmpty(event)) {
    phoneLink = /*#__PURE__*/React.createElement(Event, {
      eventType: "click",
      event: event
    }, phoneLink);
  }
  return phoneLink;
}
Phone.defaultProps = defaultProps;